<template>
    <div class="contact-page">
        <div class="contact-section">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-12 col-lg-11">
                        <div class="title-row">
                            <div class="row">
                                <div class="col-md-12">
                                    <p class="p-title Raleway p-black"><b>Contact us</b></p>
                                    <p class="Raleway min-med p-dgrey">On this page you can contact us with any questions you may have.</p>
                                </div>
                            </div>
                        </div>
                        <div class="form_row">
                            <div class="row">
                                <div class="col-md-6 brdr-right">
                                    <div class="form_blk">
                                        <div class="titles">
                                            <p class="relawaySM med-max"><img src="/img/icon/smile.svg" alt="">Do you have any question? Contact us!</p>
                                        </div>

                                        <div class="form">
                                            <div class="filter-blck filter-dropdown" v-click-outside="closetoogleshow4">
                                                <button class="btn btn-full btn-white dropdown" @click="show4 = !show4">Fixed price 1 year</button>
                                                <transition name="fade">
                                                    <div class="dropdown__el" v-if="show4">
                                                        <div class="dropdown-list">
                                                            <div class="dropdown-item">Fixed price 6 months</div>
                                                            <div class="dropdown-item">Fixed price 6 months</div>
                                                            <div class="dropdown-item">Fixed price 6 months </div>
                                                            <div class="dropdown-item">Fixed price 6 months</div>
                                                            <div class="dropdown-item">Fixed price 6 months</div>
                                                        </div>
                                                    </div>
                                                </transition>
                                            </div>
                                            <div class="form-group">
                                                <label @click="forLabelClick($event)">Firstname</label>
                                                <input type="text" class="form-control"
                                                       @focus="formControlFocus($event)"
                                                       @blur="formControlBlur($event)"

                                                       title="Phone number">
                                            </div>
                                            <div class="form-group error">
                                                <label @click="forLabelClick($event)"><img src="../../../img/icon/exclamation-sign.svg" alt=""> Lastname</label>
                                                <input type="text" class="form-control"
                                                       @focus="formControlFocus($event)"
                                                       @blur="formControlBlur($event)"

                                                       title="Phone number">
                                            </div>
                                            <div class="form-group">
                                                <label @click="forLabelClick($event)">E-mail</label>
                                                <input type="text" class="form-control"
                                                       @focus="formControlFocus($event)"
                                                       @blur="formControlBlur($event)"

                                                       title="Phone number">
                                            </div>
                                            <div class="form-group">
                                                <label @click="forLabelClick($event)">Cellphone number</label>
                                                <input type="text" class="form-control"
                                                       @focus="formControlFocus($event)"
                                                       @blur="formControlBlur($event)"

                                                       title="Phone number">
                                            </div>
                                            <div class="form-group textarea">
                                                <label @click="forLabelClick($event)">Your message</label>
                                                <textarea class="form-control"
                                                          @focus="formControlFocus($event)"
                                                          @blur="formControlBlur($event)"

                                                          title="Phone number"></textarea>
                                            </div>
                                            <div class="btns">

                                                <button class="btn btn-green btn-full">contact us</button>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-md-6">
                                    <div class="contact__info">
                                        <div class="titles">
                                            <p class="relawaySM med-max">Company information</p>
                                        </div>
                                        <div class="name">
                                            <p class="max-max p-blue">TecknaSmart Sverige AB</p>
                                        </div>
                                        <div class="name">
                                            <p class="min"><b>Org. Number:</b> 559171-8522</p>
                                        </div>
                                        <div class="name">
                                            <p class="min"><b>Epost</b> <a href="#">info@tecknael.se</a></p>
                                        </div>
                                        <div class="address__info">
                                            <p class="min"><b>Post adress:</b></p>
                                            <p class="min">TecknaSmart Sverige AB Kund-id WINXXXX, FE nr XXX 105 69 Stockholm</p>
                                        </div>
                                        <div class="address__info">
                                            <p class="min"><b>Visitor adress:</b></p>
                                            <p class="min">TecknaSmart Sverige AB Markvardsgatan 15 113 54 Stockholm</p>
                                        </div>
                                        <div class="faq__blck" style="display: none">
                                            <div class="titles">
                                                <p class="Raleway med-max"><b>FAQ</b></p>
                                            </div>
                                            <div class="faq-list">
                                                <div class="faq__item"
                                                     v-for="(item, index) in faq"
                                                     :class="{ 'open' : index ===  current_index}"
                                                >
                                                    <div class="row">
                                                        <div class="col-10" @click="openFaq(index)">
                                                            <div class="title">
                                                                <p class="min p-dgrey  mb-0">{{item.title}}</p>
                                                            </div>
                                                            <transition name="fade">
                                                                <div class="content" v-if="index ===  current_index">
                                                                    <p class="min-min p-dgrey mb-0">{{item.content}}</p>
                                                                </div>
                                                            </transition>
                                                        </div>
                                                        <div class="col-2">
                                                            <div class="icon" @click="openFaq(index)">
                                                                <span></span>
                                                                <span></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <faq-new background="bg-white"></faq-new>
    </div>
</template>

<script>
    import FaqNew from './page-part/FaqNew'


    var faq_data = [
        {
            title: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur"
        },
        {
            title: "2 Lorem ipsum dolor sit amet, consectetur ",
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur"
        },
        {
            title: "3 Lorem ipsum dolor sit amet, consectetur ",
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur"
        },
        {
            title: "4 Lorem ipsum dolor sit amet, consectetur ",
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur"
        },
        {
            title: "5 Lorem ipsum dolor sit amet, consectetur ",
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur"
        },
    ];


    export default {
        name: "Contact",
        components:{
            FaqNew
        },
        data: function(){
            return {
                show4: false,
                faq: faq_data,
                current_index: '',
            }

        },
        methods: {
            openFaq: function(index){
                if(index === this.current_index){
                    this.current_index = '';
                } else {
                    this.current_index = index;
                }
            },
            closetoogleshow4(){
                this.show4 = false
            },
            formControlFocus($event){
                $event.target.parentElement.classList.add('active');

            },
            formControlBlur($event){
                if($event.target.value === ""){
                    $event.target.parentElement.classList.remove('active');

                }

            },
            forLabelClick($event){
                console.log($event);
                if(!$event.target.parentElement.classList.contains("disabled")){
                    $event.target.parentElement.classList.add('active');
                    $event.target.parentElement.children[1].focus();
                }

            },
        }

    }
</script>
